import { ID } from '@datorama/akita';

import { Deserializable } from '../../shared/models/deserializable.model';

export class AdminUser implements Deserializable {
  id: ID;
  username: string;
  email: string;
  firstName: string;
  lastName: string;

  deserialize(input: any) {
    Object.assign(this, input);
    return this;
  }
}
